import Vue from 'vue';
import Router from 'vue-router';
import {
    storage
} from 'BASE/common/util/util.storage';

const CenterTopMenu = () => import('YD/views/CenterTopMenu.vue');
const Login = () => import('YD/views/Login/Login.vue');
const ChatAnonymity = () => import('YD/views/ChatAnonymity/ChatAnonymity.vue');
const Timeout = () => import('YD/views/ErrorHandle/Timeout.vue');
const Offline = () => import('YD/views/ErrorHandle/Offline.vue');
const Home = () => import('YD/views/Home/Home.vue');
const ErrorMsg = () => import('YD/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('YD/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('YD/views/Register/Register.LinkFailure.vue');
const Bet = () => import('YD/views/Bet/Bet.vue');
const MultiBet = () => import('YD/views/MultiBet/MultiBet.vue');

const AccountInfo = () => import('YD/views/AccountCenter/AccountInfo.vue');
const AwardDetail = () => import('YD/views/AwardDetail/AwardDetail.vue');
const MyDailyPayAndContract = () => import('YD/views/MyDailyPayAndContract/MyDailyPayAndContract.vue');
const AccountSecurity = () => import('YD/views/AccountCenter/AccountSecurity.vue');
const LoginRecord = () => import('YD/views/LoginRecord/LoginRecord.vue');
const DepositRequestCreate = () => import('YD/views/DepositRequest/Create.vue');
const DepositQrcode = () => import('YD/views/DepositRequest/DepositQrcode.vue');
const DepositPayInfo = () => import('YD/views/DepositRequest/PayInfo.vue');
const CreatePlayer = () => import('YD/views/Player/Player.Create.vue');
const Player = () => import('YD/views/Player/Player.vue');
const BonusManagement = () => import('YD/views/BonusManagement/BonusManagement.vue');
const HelperCenter = () => import('YD/views/HelperCenter/HelperCenter.vue');
const WithdrawRequest = () => import('YD/views/WithdrawRequest/WithdrawRequest.vue');
const RegisterLink = () => import('YD/views/RegisterLink/RegisterLink.vue');
const BankCard = () => import('YD/views/BankCard/BankCard.vue');
const CreateBankCard = () => import('YD/views/BankCard/BankCard.Create.vue');
const CreateAliPay = () => import('YD/views/BankCard/AliPay.Create.vue');
const CreateWeChat = () => import('YD/views/BankCard/WeChat.Create.vue');
const CreateENCY = () => import('YD/views/BankCard/ENCY.Create.vue');
const Register = () => import('YD/views/Register/Register.vue');
const DepositAndWithdrawRecord = () => import('YD/views/DepositAndWithdrawRecord/DepositAndWithdrawRecord.vue');
const ExternalGameTransRecord = () => import('YD/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const ExternalGameSubItem = () => import('YD/views/ExternalGame/ExternalGameSubItem.vue');
const ExternalGameLobby = () => import('YD/views/ExternalGame/ExternalGameLobby.vue');
const ExternalGameSportLobby = () => import('YD/views/ExternalGame/ExternalGameSportLobby.vue');
const ExternalGameCardLobby = () => import('YD/views/ExternalGame/ExternalGameCardLobby.vue');
const ExternalGameVideoLobby = () => import('YD/views/ExternalGame/ExternalGameVideoLobby.vue');
const TrendChartStatistics = () => import('YD/views/TrendChart/Statistics.vue');
const TrendChartOverview = () => import('YD/views/TrendChart/Overview.vue');
const TransferPointRecord = () => import('YD/views/TransferPointRecord/TransferPointRecord.vue');
const Transfer = () => import('YD/views/TransferPoint/Transfer.vue');
const UserStatisticsReport = () => import('YD/views/UserStatisticsReport/UserStatisticsReport.vue');
const BetRecord = () => import('YD/views/BetRecord/BetRecord.Main.vue');
const DividendRecord = () => import('YD/views/DividendRecord/DividendRecord.vue');
const ProportionalDividend = () => import('YD/views/ProportionalDividend/ProportionalDividend.vue');
const ExternalGameProportionalDividend = () => import('YD/views/ExternalGameProportionalDividend/ExternalGameProportionalDividend.vue');
const ProfitReport = () => import('YD/views/ProfitReport/ProfitReport.Main.vue');
const ScheduleRecord = () => import('YD/views/ScheduleRecord/ScheduleRecord.Main.vue');
const CashFlowRecord = () => import('YD/views/CashFlowRecord/CashFlowRecord.Main.vue');
const LotteryGameStatistics = () => import('YD/views/LotteryGameStatistics/LotteryGameStatistics.Main.vue');
const DrawHistory = () => import('YD/views/DrawHistory/DrawHistory.vue');
const CreateUSDTAddress = () => import('YD/views/USDTAddress/USDTAddress.Create.vue');
const ElectronicPurseManualCreate = () => import('YD/views/ElectronicPurse/ElectronicPurse.create.manual.vue');
const ElectronicPurseQRCodeCreate = () => import('YD/views/ElectronicPurse/ElectronicPurse.create.qrcode.vue');
const IFrame = () => import('YD/views/IFrame.vue');
const Activity = () => import('YD/views/Activity/Activity.vue');
const ActivityTreasure = () => import('YD/views/Activity/DailyTreasureChestMission.vue');
const ActivityRelief = () => import('YD/views/Activity/ReliefPackageActivity.vue');
const VIPInfo = () => import('YD/views/VIP/VIPInfo.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [{
            path: '/Login',
            name: 'Login',
            component: Login,
            meta: {
                ignoreAuth: true
            }
        },
        {
            path: '/ChatAnonymity',
            name: 'ChatAnonymity',
            component: ChatAnonymity,
            meta: {
                ignoreAuth: true
            }
        },
        {
            path: '/Timeout',
            name: 'Timeout',
            component: Timeout,
            meta: {
                ignoreAuth: true
            }
        },
        {
            path: '/Offline',
            name: 'Offline',
            component: Offline,
            meta: {
                ignoreAuth: true
            }
        },
        {
            path: '/LinkFailure',
            name: 'LinkFailure',
            component: LinkFailure,
            meta: {
                ignoreAuth: true
            }
        },
        {
            path: '/ErrorMsg',
            name: 'ErrorMsg',
            component: ErrorMsg,
            meta: {
                ignoreAuth: true
            }
        },
        {
            path: '/IPRestricted',
            name: 'IPRestricted',
            component: IPRestricted,
            meta: {
                ignoreAuth: true
            }
        },
        {
            path: '/DepositPayInfo/:SerialNumber',
            name: 'DepositPayInfo',
            component: DepositPayInfo,
            meta: {
                ignoreAuth: true
            },
        },
        {
            path: '/Register/:code',
            name: 'Register',
            component: Register,
            meta: {
                ignoreAuth: true
            }
        },
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/Bet/:id',
            name: 'Bet',
            component: Bet
        },
        {
            path: '/MultiBet/:type',
            name: 'MultiBet',
            component: MultiBet
        },
        {
            path: '/DepositQrcode',
            name: 'DepositQrcode',
            component: DepositQrcode
        },
        {
            path: '/HelperCenter',
            component: HelperCenter
        },
        {
            path: '/ExternalGameSubItem/:gameType',
            component: ExternalGameSubItem
        },
        {
            path: '/ExternalGameLobby/:gameCategory',
            component: ExternalGameLobby
        },
        {
            path: '/ExternalGameSportLobby',
            name: 'ExternalGameSportLobby',
            component: ExternalGameSportLobby
        },
        {
            path: '/ExternalGameCardLobby',
            name: 'ExternalGameCardLobby',
            component: ExternalGameCardLobby
        },
        {
            path: '/ExternalGameVideoLobby',
            name: 'ExternalGameVideoLobby',
            component: ExternalGameVideoLobby
        },
        {
            path: '/Activity',
            name: 'Activity',
            component: Activity
        },
        {
            path: '/ActivityTreasure',
            name: 'ActivityTreasure',
            component: ActivityTreasure
        },
        {
            path: '/ActivityRelief',
            name: 'ActivityRelief',
            component: ActivityRelief
        },
        {
            path: '/Center',
            component: CenterTopMenu,
            children: [{
                    path: 'AccountInfo',
                    component: AccountInfo
                },
                {
                    path: 'AwardDetail',
                    component: AwardDetail
                },
                {
                    path: 'MyDailyPayAndContract',
                    component: MyDailyPayAndContract
                },
                {
                    path: 'BankCard',
                    name: 'BankCard',
                    component: BankCard
                },
                {
                    path: 'CreateBankCard',
                    name: 'CreateBankCard',
                    component: CreateBankCard
                },
                {
                    path: '/CreateAliPay/:CurrentBankType',
                    name: 'CreateAliPay',
                    component: CreateAliPay,
                    props: true
                },
                {
                    path: '/CreateWeChat/:CurrentBankType',
                    name: 'CreateWeChat',
                    component: CreateWeChat,
                    props: true
                },
                {
                    path: '/CreateECNY/:CurrentBankType',
                    name: 'CreateENCY',
                    component: CreateENCY,
                    props: true
                },
                {
                    path: 'AccountSecurity',
                    component: AccountSecurity
                },
                {
                    path: 'LoginRecord',
                    component: LoginRecord
                },
                {
                    path: 'DepositCreate',
                    component: DepositRequestCreate
                },
                {
                    path: 'CreatePlayer',
                    component: CreatePlayer,
                    meta: {
                        isAgentAllow: true
                    }
                },
                {
                    path: 'Player',
                    component: Player,
                    meta: {
                        isAgentAllow: true
                    }
                },
                {
                    path: 'BonusManagement',
                    component: BonusManagement,
                    meta: {
                        isAgentAllow: true
                    }
                },
                {
                    path: 'WithdrawRequest',
                    component: WithdrawRequest
                },
                {
                    path: 'RegisterLink',
                    component: RegisterLink,
                    meta: {
                        isAgentAllow: true
                    }
                },
                {
                    path: 'ExternalGameTransRecord',
                    component: ExternalGameTransRecord
                },
                {
                    path: 'DepositAndWithdrawRecord',
                    component: DepositAndWithdrawRecord
                },
                {
                    path: 'TrendChartStatistics',
                    component: TrendChartStatistics,
                    meta: {
                        isAgentAllow: true
                    }
                },
                {
                    path: 'TrendChartOverview',
                    component: TrendChartOverview,
                    meta: {
                        isAgentAllow: true
                    }
                },
                {
                    path: 'TransferPointRecord',
                    component: TransferPointRecord
                },
                {
                    path: 'UserStatisticsReport',
                    component: UserStatisticsReport,
                    meta: {
                        isAgentAllow: true
                    }
                },
                {
                    path: 'Transfer',
                    name: 'Transfer',
                    component: Transfer
                },
                {
                    path: 'BetRecord',
                    name: 'BetRecord',
                    component: BetRecord
                },
                {
                    path: 'DividendRecord',
                    name: 'DividendRecord',
                    component: DividendRecord
                },
                {
                    path: 'ProportionalDividend',
                    name: 'ProportionalDividend',
                    component: ProportionalDividend
                },
                {
                    path: 'ExternalGameProportionalDividend',
                    name: 'ExternalGameProportionalDividend',
                    component: ExternalGameProportionalDividend
                },
                {
                    path: 'ProfitReport',
                    component: ProfitReport
                },
                {
                    path: 'ScheduleRecord',
                    component: ScheduleRecord
                },
                {
                    path: 'CashFlowRecord',
                    component: CashFlowRecord
                },
                {
                    path: 'LotteryGameStatistics',
                    component: LotteryGameStatistics
                },
                {
                    path: 'VIPInfo',
                    component: VIPInfo
                },
                {
                    path: 'CreateUSDTAddress',
                    name: 'CreateUSDTAddress',
                    component: CreateUSDTAddress
                },
                {
                    path: 'CreateElectronicPurseManual',
                    name: 'ElectronicPurseManualCreate',
                    component: ElectronicPurseManualCreate,
                    props: true
                },
                {
                    path: 'CreateElectronicPurseQRCode',
                    name: 'ElectronicPurseQRCodeCreate',
                    component: ElectronicPurseQRCodeCreate,
                    props: true
                },
            ],
        },
        {
            path: '/DrawHistory/:id',
            name: 'DrawHistory',
            component: DrawHistory
        },
        {
            path: '/IFrame',
            name: 'IFrame',
            component: IFrame
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == 'Login') {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some((record) => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some((record) => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        } else if (to.name === 'Home' && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/speedtest');
        } else {
            next('/Timeout'); // 認證已過期
        }
    }
});

export default router;